module.exports = __webpack_public_path__ + "img/Icons-forum menu.0931c4a1.svg";